<template>
  <v-row
    :class="{
      'mt-6': $vuetify.breakpoint.smAndDown
    }"
  >
    <v-col class="d-flex justify-space-around" cols="12" md="10">
      <v-row no-gutters>
        <v-col cols="12" sm="12" md="4" class="pt-0">
          <v-text-field
            v-model="code"
            clear-icon="mdi-close"
            placeholder="Mã CSVC"
            deletable-chips
            clearable
            dense
            filled
            :required="false"
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="12" md="4" class="pt-0">
          <v-autocomplete
            :items="allFacilityStatus"
            v-model="status"
            item-text="title"
            item-value="status"
            clear-icon="mdi-close"
            placeholder="Trạng thái"
            clearable
            single
            filled
            dense
          ></v-autocomplete>
        </v-col>
        <v-col cols="12" sm="12" md="4" class="pt-0">
          <DateRangePicker
            placeholder="Hạn trả  "
            :date-range.sync="dateRange"
            dense
            filled
          />
        </v-col>
      </v-row>
    </v-col>
    <v-col
      cols="12"
      class="d-flex justify-end"
      :class="{
        'pr-6': $vuetify.breakpoint.mdAndUp,
        'pr-4 mt-n4': $vuetify.breakpoint.smAndDown
      }"
      md="2"
    >
      <v-btn
        depressed
        height="38px"
        color="amber darken-1"
        dark
        @click="onFilterChanged"
      >
        <v-icon left dark>mdi-filter-outline</v-icon>Lọc
      </v-btn>
    </v-col>
  </v-row>
</template>

<script>
import { mapState } from 'vuex'
import moment from 'moment'
import DateRangePicker from '@/components/basic/picker/DateRangeIOSPicker'

export default {
  components: { DateRangePicker },
  props: {
    defaultFilters: Object
  },
  data: () => ({
    query: '',
    status: '',
    code: '',
    time: null,
    staff: null,
    deadline_gt: '',
    deadline_lt: '',
    dateRange: []
  }),
  computed: {
    ...mapState('constant', ['facilityStatus', 'facilityTypes']),
    allFacilityStatus() {
      return [
        {
          title: 'Tất cả trạng thái',
          status: ''
        },
        ...this.facilityStatus
      ]
    }
  },
  methods: {
    onFilterChanged() {
      this.deadline_gt = ''
      this.deadline_lt = ''
      if (this.dateRange.length > 1) {
        this.deadline_gt = moment(this.dateRange[0], 'DD/MM/YYYY').toISOString()
        this.deadline_lt = moment(this.dateRange[1], 'DD/MM/YYYY')
          .add(1, 'd')
          .toISOString()
      } else if (this.dateRange.length > 0) {
        this.deadline_gt = moment(this.dateRange[0], 'DD/MM/YYYY').toISOString()
        this.deadline_lt = moment(this.dateRange[0], 'DD/MM/YYYY')
          .add(1, 'd')
          .toISOString()
      }
      this.$emit('onFilterChanged', {
        code_contains: this.code,
        status: this.status,
        deadline_gt: this.deadline_gt,
        deadline_lt: this.deadline_lt
      })
    }
  }
}
</script>
<style scoped>
.v-input--selection-controls,
.v-input__slot {
  margin: 0;
  padding: 0;
}
</style>
